export const List = () => import("./List.vue");
export const TreeView = () => import("./TreeView.vue");
export const TreeAddEdit = () => import("./TreeAddEdit.vue");
export const Create = () => import("./Create.vue");
export const Edit = () => import("./Edit.vue");
export const Show = () => import("./Show.vue");
export const AddUser = () => import("./AddUser.vue");
export const TreeViewOrg = () => import("./TreeViewOrg.vue");
export const AddAppointments = () => import("./AddAppointments.vue");
export const AppointmentView = () => import("./AppointmentView.vue");
export const TreeCreate = () => import("./TreeCreate.vue");
export const TreeEdit = () => import("./TreeEdit.vue");
export const Setup = () => import("./Setup.vue");
export const Auth = () => import("./Auth.vue");
